<template>
  <pt-third-vendors-detail class="pt-third-vendors-detail__page"></pt-third-vendors-detail>
</template>

<script>
import PtThirdVendorsDetail from 'cps/mall-manage/pt-third-vendors/pt-third-vendors-detail/withData'
export default {
  name: 'pt-third-vendors-detail__view',
  components: {
    'pt-third-vendors-detail': PtThirdVendorsDetail
  }
}
</script>
